module.exports = __webpack_public_path__ + "img/40_38_087_350.f9dd7270.jpg";